import React, { useEffect, useState } from "react";
import SidebarLayout from './SidebarLayout';
import { Row, Col, Card, Input, Select, Typography, Divider, Button, Tag, DatePicker, Space, Tooltip, Collapse, Spin, Comment, message } from "antd";
import { SearchOutlined, RightOutlined, FileSearchOutlined, QuestionCircleOutlined, FlagOutlined, MessageOutlined, ArrowRightOutlined } from "@ant-design/icons";
import _BankerService from "../../modules/BankerService";
import { useHistory } from "react-router-dom";
import _commonService from "../../modules/commonService";
import moment from "moment";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import { UnderReviewStatusId } from "../../constants/DataConstants";
import StatusTag from "../../components/StatusTag";

const { Title, Text, Link } = Typography;
const { Panel } = Collapse;

const { Option } = Select;

const RevisionRequest = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [applications, setApplications] = useState([]);
  const bankerIdRaw = localStorage.getItem("BankerId");
  const BankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;
  const RoleId = Number(localStorage.getItem("RoleId") ?? 0);

  useEffect(() => {
    getBankerRevistApplicationListByBankerId();
  }, [])

  const getBankerRevistApplicationListByBankerId = async () => {
    try {
      setLoading(true)
      const params = {
        bankerId: BankerId,
        startDate: "2025-01-01",
        endDate: "2025-12-31",
        pageIndex: 1,
        pageSize: 10,
        searchTerm: "a",
        sortBy: "id",
        sortAsc: false
      };

      const response = await _BankerService.getBankerRevistApplicationListByBankerId(params);

      if (response?.data?.IsSuccess) {
        setLoading(false);
        const applicationList = response.data.Obj.List;
        setApplications(applicationList);
      }
      else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching applications:", error);
    }
  };

  const handleClickUpdateApplicantStatus = async (item) => {
    if (item && item.Application_Status_Id && (item.Application_Status_Id != 4 && item.Application_Status_Id != 5 && item.Application_Status_Id != 8 && item.Application_Status_Id != 9)) {
      let reqObj = {
        Id: item.Id,
        ApplicationId: item.ApplicationId,
        Application_Status_Id: UnderReviewStatusId,
        BankerId: BankerId,
        LoanOfficerId: null,
        RoleId: RoleId || null
      }
      setLoading(true);
      try {
        const res = await _BankerService.updateApplicantStatus(reqObj);
        if (res.data.IsSuccess) {
          setLoading(false);
          //message.success(res.data.Message);
          history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
        } else {
          setLoading(false);
          message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
        }
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
      finally {
        setLoading(false);
      }
    } else {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
    }
  }

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div>
          <div style={{ display: 'block', fontSize: "14px" }}>
            <Title level={3}>Revisit Applications List <QuestionCircleOutlined /> </Title>
          </div>
          <div style={{ padding: 24, background: "#f9fbfd", borderRadius: 12, marginTop: 20 }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <Text type="secondary">Revision Requests: <strong>{applications && applications.length || "0"}</strong></Text>
              </Col>
            </Row>

            <Row gutter={[16, 16]} align="middle" style={{ display: 'none' }}>
              <Col xs={24} sm={12} md={6}>
                <Input
                  placeholder="Search"
                  suffix={<SearchOutlined />}
                  style={{ borderRadius: 20 }}
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <DatePicker
                  placeholder="From: YY-MM-DD"
                  style={{ width: "100%", borderRadius: 20 }}
                />
              </Col>
              <Col xs={12} sm={6} md={4}>
                <DatePicker
                  placeholder="To: YY-MM-DD"
                  style={{ width: "100%", borderRadius: 20 }}
                />
              </Col>
              <Col xs={24} sm={6} md={4}>
                <Select
                  placeholder="Sort By"
                  style={{ width: "100%", borderRadius: 20 }}
                >
                  <Option value="date">Date</Option>
                  <Option value="status">Status</Option>
                </Select>
              </Col>
            </Row>
          </div>
          {applications && applications.map((app, index) => {

            // const latestloanOfficerName = app && app.listApplicationReviewCommentModels &&
            //   app.listApplicationReviewCommentModels
            //     .filter(item => item.ReviewCommentsBy_LoanOfficerId > 0)
            //     .sort((a, b) => new Date(b.ReviewCommentDate) - new Date(a.ReviewCommentDate))[0];

            return (
              <Card key={index} className="mb15 cardStyle" style={{ marginTop: 20 }}>
                <Collapse
                  accordion expandIconPosition="end"
                  ghost
                  expandIcon={({ isActive }) => (
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#414957",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.3s",
                        transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                      }}
                    >
                      <RightOutlined style={{ color: "white", fontSize: 12 }} />
                    </div>
                  )}
                >
                  <Panel
                    key="1"
                    header={
                      <Space align="start">
                        <div>
                          <Row justify="space-between" align="middle" gutter={[16, 16]}>
                            {/* Left Icon */}
                            <Col>
                              <FileSearchOutlined style={{ fontSize: 50, color: "#8c8c8c" }} />
                            </Col>

                            {/* Middle Text Info */}
                            <Col flex="auto">
                              <Space direction="vertical" size={4}>
                                <Text>
                                  Application: <Text strong>{app.ApplicationId}</Text>{" "}
                                  <span style={{ margin: "0 12px" }}>|</span>
                                  Applicant: <Text strong>{app.ApplicantName}</Text>{" "}
                                  <span style={{ margin: "0 12px" }}>|</span>
                                  Loan Amount: <Text strong>$ {_commonService.formatNumberWithCommas(app.ApplicantLoanAmount)}</Text>
                                </Text>

                                {/* Tags (You can dynamically show based on status later) */}
                                <Space size="middle">
                                  <StatusTag statusId={app && app.Application_Status_Id} />
                                  {/* <span style={{ margin: "0 10px" }}>|</span>
                                  <Text>Invalid Documents</Text>
                                  <span style={{ margin: "0 10px" }}>|</span>
                                  <Text>Re-evaluate Application</Text> */}
                                </Space>
                              </Space>
                            </Col>
                          </Row>
                        </div>
                      </Space>
                    }
                  >
                    <Divider style={{ margin: "16px 0" }} />
                    <Row justify="space-between" style={{ width: "100%" }}>
                      <Col
                        xs={24} sm={24} md={24}>
                        {
                          app.listApplicationReviewCommentModels?.map((comment, index) =>
                            // (comment.Remarks || comment.Comments) && (
                              <Comment
                                key={index}
                                className='revisitComment'
                                avatar={
                                  <MessageOutlined
                                    style={{
                                      fontSize: 24,
                                      color: "#999",
                                      marginTop: 8,
                                    }}
                                  />
                                }
                                content={
                                  <>
                                    {/* {comment.Remarks && ( */}
                                      {/* <p className='mb10'><strong>Remarks:</strong> {comment.Remarks || "N/A"}</p> */}
                                    {/* )} */}
                                    {/* {comment.Comments && ( */}
                                      <p className='mb10'><strong>Comments:</strong> {comment.Comments || "N/A"}</p>
                                    {/* )} */}
                                      <p className='mb10'><strong>Date & Time:</strong> {comment.ReviewCommentDate ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate) : "N/A"}</p>
                                  </>
                                }
                              />
                            // )
                          )
                        }
                      </Col>

                    </Row>
                  </Panel>
                </Collapse>

                {/* Footer */}
                <Divider style={{ margin: "16px 0" }} />
                <Row justify="space-between" align="middle" style={{ marginLeft: "16px" }}>
                  <Col>
                    <Space size="middle">
                      {/* <Text type="secondary">
                        Loan Officer: {latestloanOfficerName?.ReviewCommentsLoanOfficerName || "N/A"}
                      </Text>
                      <Text type="secondary">•</Text> */}
                      <label>
                        <Text strong>Date & Time:</Text> {app?.CreatedDate ? _commonService.formatDateTimeAMPM(app.CreatedDate) : "N/A"}
                      </label>
                    </Space>
                  </Col>
                  <Col>
                    <Button
                      type="link"
                      className="fRight viewBtn"
                      onClick={() => { handleClickUpdateApplicantStatus(app) }}
                      
                    // onClick={() => history.push(`/loanApplicationDetails/${app.Id}`)}
                    >
                     <span>View Application</span>
                     <ArrowRightOutlined style={{ fontSize: 'inherit',marginTop:"8px"}} />
                    </Button>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default RevisionRequest;


